import { render, staticRenderFns } from "./DeleteTestButton.vue?vue&type=template&id=4e8e5db7&scoped=true"
import script from "./DeleteTestButton.vue?vue&type=script&lang=ts"
export * from "./DeleteTestButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e5db7",
  null
  
)

export default component.exports